module.exports = __webpack_public_path__ + "img/britain.fd7c4c0.svg";